// @flow
import React, { Fragment, useContext } from 'react';

import appConfig from 'Config';
import ReactAppContext from 'Context/ReactAppContext';

export const Sentry = () => {
  const { locale } = useContext(ReactAppContext);
  const appVersion = appConfig.get('APP_VERSION');
  const deploymentEnv = appConfig.get('DEPLOYMENT_ENV');
  const sentry = appConfig.get('clientError.sentry');

  if (sentry.enabled && sentry.url && sentry.dsn) {
    return (
      <Fragment>
        <script src={sentry.url} crossOrigin="anonymous" />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              if (window.Sentry) {
                Sentry.init({
                  dsn: '${sentry.dsn}',
                  environment: '${deploymentEnv}',
                  release: '${appVersion}',
                });
                Sentry.configureScope(function (scope) {
                  scope.setExtra('locale', '${locale}');
                  scope.setTag('locale', '${locale}');
                });
              }
          `,
          }}
        />
      </Fragment>
    );
  }

  return null;
};
